module.exports = __webpack_public_path__ + "img/icon-open-popup-normal.2056fc0e.svg";